import { fromJS, Map } from 'immutable';

export function request(state, { id }) {
    return state.mergeIn(
        [ 'items', id ],
        Map({
            state: 'IN_PROGRESS'
        })
    );
}

export function error(state, { id, errors }) {
    return state.mergeIn(
        [ 'items', id ],
        Map({
            state: 'ERROR',
            errors: fromJS(errors)
        })
    );
}

export function finish(state, { id, transaction }) {
    return state.mergeIn(
        [ 'items', id ],
        fromJS(transaction).merge({
            state: 'FINISHED'
        })
    );
}
